import { Box, ColorOptions, ModBox, Spacer, TextNew } from '@jfs/ui-new'
import { DateFormatTypes, dateFormatter2 as dateFormatter, getRangeDate } from '@jfs/utils'
import React, { FC, ReactElement } from 'react'
import ReactDOM from 'react-dom'
import { Dimensions } from 'react-native'
import CalendarViewModal from '../CalendarViewModal'
import { CalendarTypes } from './../Calendar'
import { styles } from './styles'

export interface DateType {
  fromDate: Date
  toDate?: Date
  position?: { left?: number; top?: number; visible: boolean }
}

interface layoutPosition {
  clientY: number
  offsetY: number
  clientX: number
  offsetX: number
}

const deflayoutPosition = {
  clientY: 0,
  offsetY: 0,
  clientX: 0,
  offsetX: 0,
}
interface DateSelectorProp {
  value: DateType
  onPress?: (data: string) => void
  path?: string
  onDateSelected?: (dateObj: DateType) => void
  setNewDate: (data: any) => void
  defaultMinDate?: Date
  isFocused: boolean
  defaultMaxDate?: Date
  maxDuration?: number
  scrollToCurrentDate?: boolean
  sendError?: any
}

const DateSelector: FC<DateSelectorProp> = ({
  value: { fromDate, toDate, position },
  onDateSelected,
  setNewDate,
  path,
  defaultMinDate,
  isFocused,
  defaultMaxDate,
  maxDuration,
  scrollToCurrentDate,
  sendError,
}: DateSelectorProp) => {
  const calendarWebWidth = 690
  //const [layoutPosition, setPosition] = useState<layoutPosition>(deflayoutPosition)
  const windowWidth = Dimensions.get('window').width
  //const leftPos = layoutPosition?.clientX - layoutPosition?.offsetX
  const remainingWidth = windowWidth - calendarWebWidth
  const isWebCalendarOpenInNative = windowWidth - calendarWebWidth < 200

  const onDateSelection = (firstdate: Date, secondDate?: Date): void => {
    if (secondDate) {
      const dateObj: DateType = { fromDate: firstdate, toDate: secondDate }
      if (onDateSelected) {
        onDateSelected(dateObj)
      }
      setNewDate({
        fromDate: firstdate,
        toDate: secondDate,
        position: {
          //top: position?.top,
         // left: position?.left,
          visible: !position?.visible,
        },
      })
    }
  }

  const handleCancel = (): void => {
    handleDateSelected()
  }

  const handleDateSelected = () => {
    setNewDate({
      fromDate,
      toDate,
      position: {
       // top: position?.top,
       // left: position?.left,
        visible: !position?.visible,
      },
    })
  }

  const onPressButton = (evt: any): void => {
    //setPosition(evt?.nativeEvent)
    console.log( evt.nativeEvent.pageY - evt.nativeEvent.locationY + styles.dimens.top)
    console.log(evt.nativeEvent)
    setNewDate({
      fromDate,
      toDate,
      position: {
        top: evt.nativeEvent.clientY - evt.nativeEvent.offsetY + styles.dimens.top,
        left: evt.nativeEvent.clientX - evt.nativeEvent.offsetX - styles.dimens.right,
        visible: !position?.visible,
      },
    })
  }

  const returnLeftValue = () => {
    if (remainingWidth < calendarWebWidth || isWebCalendarOpenInNative) {
      console.log('returnLeftValue undefined')
      return undefined
    } else if (!isWebCalendarOpenInNative) {
    //  console.log('returnLeftValue: ', leftPos)
      return position.left
    }
  }

  const returnTopValue = () => {
   
    //return layoutPosition?.clientY - layoutPosition?.offsetY + 30
    console.log(position)
    return position?.top
  }

  const returnRightValue = () => {
    if (remainingWidth < calendarWebWidth || isWebCalendarOpenInNative) {
      console.log('returnRightValue: ', 17)
      return 17
    } else {
      console.log('returnRightValue: ', undefined)
      return undefined
    }
  }

 

  const renderCalendarModal = (): ReactElement => {
    return (
      <ModBox {...styles.modal} underlayColor="TRANSPARENT" show={position?.visible}>
        <ModBox underlayColor={'TRANSPARENT'} {...styles.overlayStyle}>
          <ModBox {...styles.dropdownStyle} right={returnRightValue()} left={returnLeftValue()} top={returnTopValue()}>
            <CalendarViewModal
              onDateSelection={onDateSelection}
              dateRange={getRangeDate(fromDate, toDate)}
              type={CalendarTypes.HISTORY}
              onCancel={handleCancel}
              defaultMinDate={defaultMinDate}
              defaultMaxDate={defaultMaxDate}
              maxDuration={maxDuration}
              scrollToCurrentDate={scrollToCurrentDate}
              sendError={sendError}
            />
          </ModBox>
        </ModBox>
      </ModBox>
    )
  }

  const renderPortal = (): React.ReactPortal => {
    return ReactDOM.createPortal(renderCalendarModal(), document.body)
  }

  const getDate = (): ReactElement => {
    if (toDate && fromDate.toLocaleDateString() !== toDate.toLocaleDateString()) {
      return (
        <ModBox {...styles.row}>
          <Spacer direction="horizontal" size={8} />
          <TextNew type={'body12'} color={'#A0A0A0' as ColorOptions}>
            {'To'}
          </TextNew>
          <Spacer direction="horizontal" size={8} />
          <TextNew type={'body12'} color={'BLACK_21'}>
            {dateFormatter(toDate, DateFormatTypes.DATE_STRING)}
          </TextNew>
        </ModBox>
      )
    }
    return <></>
  }

  const getFromDate = () => {
    return dateFormatter(fromDate, DateFormatTypes.DATE_STRING)
  }

  return (
    <Box underlayColor={'TRANSPARENT'} onPress={onPressButton} {...styles.container}>
      <ModBox {...styles.tabsCenter}>
        <ModBox {...styles.row}>
          <TextNew type={'body12'} color={'BLACK_21'}>
            {getFromDate()}
          </TextNew>
          {getDate()}
        </ModBox>
        {isFocused && renderPortal()}
      </ModBox>
    </Box>
  )
}

export { DateSelector }
